import api from "./";

export default {
    /**
     * Get Favorite
     * @param params
     */
    getFavorite(params = {}) {
        return api
            .get(`/me/activities/favorite`, {
                params: params,
            })
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Add an activity to favorite
     * @param activityId
     */
    setFavorite(activityId) {
        return api
            .post(`/me/activities/${activityId}/favorite`)
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Unfavorite an activity
     * @param activityId
     */
    setUnfavorite(activityId) {
        return api
            .post(`/me/activities/${activityId}/unfavorite`)
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Toggle favorite an activity
     * @param activityId
     */
    toggleFavorite(activityId) {
        return api
            .post(`/me/activities/${activityId}/toggleFavorite`)
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Get Bookings
     * @param params
     */
    getBookings(params = {}) {
        return api
            .get(`/me/bookings`, {
                params: params,
            })
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Get booking requests
     * @param params
     */
    getBookingRequests(params = {}) {
        return api
            .get(`/me/bookingRequests`, {
                params: params,
            })
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Get cards
     * @param params
     */
    getCardAuthorizations(params) {
        return api
            .get(`/me/cardAuthorizations`, {
                params: params,
            })
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Get cards
     * @param params
     */
    getCards(params) {
        return api
            .get(`/me/cards`, {
                params: params,
            })
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Get card transactions
     * @param params
     */
    getCardTransactions(params) {
        return api
            .get(`/me/cardTransactions`, {
                params: params,
            })
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Get credit cards
     */
    getCreditCards(params) {
        return api
            .get(`/me/creditCards`, {
                params: params,
            })
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Delete credit card
     * @param paymentMethodId
     */
    deleteCreditCard(paymentMethodId) {
        return api
            .delete(`/me/creditCards/${paymentMethodId}`)
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Setup payment method
     * @param {Object} data
     * @param {string} data.stripe_payment_method_id the Stripe payment method id
     */
    setupCreditCard(data) {
        return api
            .post(`/me/creditCards/setup`, data)
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Set a default credit card
     * @param paymentMethodId
     * @param data
     */
    setDefaultCreditCard(paymentMethodId, data) {
        return api
            .put(`/me/creditCards/${paymentMethodId}/setDefault`, data)
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Unset all default credit cards
     * @param data
     */
    unsetDefaultCreditCard(data) {
        return api
            .put(`/me/creditCards/unsetDefault`, data)
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Get expense requests
     * @param params
     */
    getExpenseRequests(params) {
        return api
            .get(`/me/expenseRequests`, {
                params: params,
            })
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Get user features
     * @param params
     */
    getFeatures(params) {
        return api
            .get(`/me/features`, {
                params: params,
            })
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Get groups
     * @param params
     */
    getGroups(params = {}) {
        return api
            .get(`/me/groups`, {
                params: params,
            })
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Get licenses
     * @param params
     */
    getLicenses(params) {
        return api
            .get(`/me/licenses`, {
                params: params,
            })
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Get notifications
     * @param params
     */
    getNotifications(params = {}) {
        return api
            .get(`/me/notifications`, {
                params: params,
            })
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Get partners
     * @param params
     */
    getPartners(params = {}) {
        return api
            .get(`/me/partners`, {
                params: params,
            })
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Get payment transactions
     * @param params
     */
    getPaymentTransactions(params) {
        return api
            .get(`/me/paymentTransactions`, {
                params: params,
            })
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Get types
     * @param params
     */
    getTypes(params) {
        return api
            .get(`/me/types`, {
                params: params,
            })
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Get profile
     * @param params
     */
    showProfile(params) {
        return api
            .get(`/me/profile`, {
                params: params,
            })
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Update profile
     * @param data
     */
    updateProfile(data) {
        return api.put(`/me/profile`, data).then((response) => {
            return response.data;
        });
    },

    /**
     * Logout user
     * @param data
     */
    logout(data) {
        return api.post(`/me/logout`, data).then((response) => {
            return response.data;
        });
    },

    /**
     * Get payment methods
     * @param params
     */
    getPaymentMethods(params) {
        return api
            .get(`/me/paymentMethods`, {
                params: params,
            })
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Get wallets
     * @param params
     */
    getWallets(params) {
        return api
            .get(`/me/wallets`, {
                params: params,
            })
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Create a wallet
     * @param data
     */
    createWallet(data) {
        return api.post(`/me/wallets`, data).then((response) => {
            return response.data;
        });
    },

    /**
     * Get allowances
     * @param params
     */
    getAllowances(params) {
        return api
            .get(`/me/allowances`, {
                params: params,
            })
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Get pending changes
     * @param params
     */
    getPendingChanges(params) {
        return api
            .get(`/me/changes/pendingList`, {
                params: params,
            })
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Resend a code to validate a change
     * @param field
     */
    resendChangeCode(field) {
        return api.post(`/me/changes/${field}/resend`).then((response) => {
            return response.data;
        });
    },

    /**
     * Validate a change
     * @param field
     * @param data
     */
    validateChange(field, data) {
        return api
            .post(`/me/changes/${field}/validate`, data)
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Cancel a change
     * @param field
     */
    cancelChange(field) {
        return api.delete(`/me/changes/${field}/cancel`).then((response) => {
            return response.data;
        });
    },

    /**
     * Mark as read all notifications
     */
    markAllNotificationsAsRead() {
        return api.post(`/me/notifications/markAsRead`).then((response) => {
            return response.data;
        });
    },

    /**
     * Get wallet transactions of the user
     * @param params
     */
    getWalletTransactions(params) {
        return api.get(`/me/walletTransactions`, { params: params }).then((response) => {
            return response.data;
        });
    },
};
